import React, { useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { Form, Row } from "react-bootstrap";
import Navbar from "../Navbar";
import axios from "axios";
import { FaUser, FaEnvelope, FaLock } from "react-icons/fa";
import { ToastContainer } from "react-toastify";
import { toastError, toastSuccess } from "../../utilis/toast";
import "react-toastify/dist/ReactToastify.css";
import { API } from "../../API";
import { useAppContext } from "../../Context/AppContext";

const FormSignUp = () => {
  const { headerLogo } = useAppContext();
  const history = useHistory();

  const [data, setData] = useState({
    name: "",
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // --------------------------------------------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  // --------------------------------------------------
  const validateForm = () => {
    const newErrors = {};

    if (!data.name.trim()) newErrors.name = "Name is required.";

    if (!data.email.trim()) newErrors.email = "Email is required.";
    else if (!/^\S+@\S+\.\S+$/.test(data.email))
      newErrors.email = "Enter a valid email.";

    if (!data.password.trim()) newErrors.password = "Password is required.";
    else if (data.password.length < 8)
      newErrors.password = "Password must be at least 8 characters.";
    else if (
      !/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])/.test(data.password)
    )
      newErrors.password =
        "Password must include uppercase, lowercase, number & special character.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // --------------------------------------------------
  const formSubmitHandler = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      setLoading(true);

      const response = await axios.post(`${API}/api/user/register`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log("response", response)
      if (response?.data?.token) {
        localStorage.setItem("Authtoken", JSON.stringify({ token: response.data.token }));

        toastSuccess("Sign Up Successful!");

        setTimeout(() => {
          history.push("/");
        }, 800);
      }

    } catch (error) {
      const errMsg =
        error?.response?.data?.message || "Sign up failed. Please try again.";
      toastError(errMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />

      {/* Toast Container */}
      <ToastContainer />

      <div className="d-flex justify-content-center align-items-center mt-5">
        <div className="form-card" style={{ width: "100%", maxWidth: "440px" }}>
          {/* Logo */}
          <div className="text-center mb-3">
            {headerLogo ? (
              <img src={headerLogo} alt="Logo" width={250} className="img-fluid" />
            ) : (
              <h1 className="text-primary fw-bold">SoComOTT</h1>
            )}
          </div>

          <h3 className="text-center mb-4">Sign Up</h3>

          <Form onSubmit={formSubmitHandler} autoComplete="off">
            {/* Name */}
            <Row className="mb-3">
              <label className="form-label">
                Name <span className="text-danger">*</span>
              </label>

              <div className="input-group">
                <span className="input-group-text">
                  <FaUser />
                </span>
                <input
                  name="name"
                  type="text"
                  value={data.name}
                  className={`form-control ${errors.name ? "is-invalid" : ""}`}
                  placeholder="Enter your name"
                  onChange={handleChange}
                />
                {errors.name && (
                  <div className="invalid-feedback">{errors.name}</div>
                )}
              </div>
            </Row>

            {/* Email */}
            <Row className="mb-3">
              <label className="form-label">
                Email <span className="text-danger">*</span>
              </label>

              <div className="input-group">
                <span className="input-group-text">
                  <FaEnvelope />
                </span>
                <input
                  name="email"
                  type="email"
                  value={data.email}
                  className={`form-control ${errors.email ? "is-invalid" : ""}`}
                  placeholder="Enter your email"
                  onChange={handleChange}
                />
                {errors.email && (
                  <div className="invalid-feedback">{errors.email}</div>
                )}
              </div>
            </Row>

            {/* Password */}
            <Row className="mb-3">
              <label className="form-label">
                Password <span className="text-danger">*</span>
              </label>

              <div className="input-group">
                <span className="input-group-text">
                  <FaLock />
                </span>
                <input
                  name="password"
                  type="password"
                  value={data.password}
                  className={`form-control ${errors.password ? "is-invalid" : ""
                    }`}
                  placeholder="Enter your password"
                  onChange={handleChange}
                />
                {errors.password && (
                  <div className="invalid-feedback">{errors.password}</div>
                )}
              </div>
            </Row>

            {/* Button */}
            <Row className="text-center mb-3 p-2">
              <button
                className="btn btn-outline-primary w-100"
                type="submit"
                disabled={loading}
              >
                {loading ? "Submitting..." : "Sign Up"}
              </button>
            </Row>
          </Form>

          <div className="text-center text-dark mt-3">
            Already have an account? <Link to="/login">Log in</Link>
          </div>
        </div>
      </div>

      <style jsx>{`
        .form-card {
          background: white;
          border-radius: 10px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          padding: 30px;
        }
      `}</style>
    </>
  );
};

export default FormSignUp;
